/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { Trans } from "react-i18next";
import { getEmployees, hideModal } from "actions";
import toastr from "toastr";
import i18n from "i18next";
import { api } from "api";

class ReActivateEmployee extends Component {


    activateEmployee = async () => {
        this.onBegin();
        await api
            .post(`/api/employee-management/reactivate/${this.props.employee.id}/${this.props.employee.companyId}`)
            .then((res) => {
                this.onActivateEmployeeSuccess();
            })
            .catch((e) => {
                this.onError(e);
            });
        this.props.hideModal();
    };

    getEmployees = () => {
        this.props.getEmployees(this.onBegin, this.onSuccess, this.onError);
    };

    onActivateEmployeeSuccess = () => {
        toastr.success(i18n.t("10570"));
        this.getEmployees();
        this.props.onProcessEnd();
        this.props.hideModal();
    };

    onBegin = () => {
        this.props.onProcessBegin();
    };

    onError = (err) => {
        console.log(err);
        toastr.error(err.response.data.message);
        this.props.onProcessEnd();
    };

    onSuccess = () => {
        this.props.onProcessEnd();
        this.props.employeelist();
    };

    renderFormHeader() {
        return null;
    }

    renderFormBody() {
        return (
            <div>
                <span>
                    <b>{this.props.employee.fullname}</b>
                </span>
                <p>
                    <Trans desc="Seçilen kullanıcı aktifleştirilecektir, onaylıyor musunuz ?">
                        10726
                    </Trans>
                </p>
            </div>
        );
    }

    renderFormFooter() {
        return (
            <div style={{ display: "flex", float: "right" }}>
                <button
                    className="btn-action btn-red mr-1"
                    onClick={() => this.props.hideModal()}
                >
                    <Trans desc="İptal">10725</Trans>
                </button>
                <button
                    className="btn-action btn-blue"
                    onClick={() => this.activateEmployee()}
                >
                    <Trans desc="Onayla">10724</Trans>
                </button>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.props.spinner}
                {this.renderFormHeader()}
                {this.renderFormBody()}
                {this.renderFormFooter()}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {};
};

export default connect(mapStateToProps, {
    getEmployees,
    hideModal,
})(containsLongRunningProcess(requireAuth(ReActivateEmployee)));
